var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2977_2979)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#29C483"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9769 7H21.7125V10.1113C22.4913 10.2324 23.2062 10.4429 23.8571 10.743C24.955 11.2394 25.8167 11.9311 26.4421 12.8181C27.0676 13.6984 27.3903 14.7112 27.4103 15.8563H23.8471C23.754 14.9892 23.3614 14.314 22.6694 13.8308C21.9841 13.3476 21.0925 13.106 19.9946 13.106C19.2227 13.106 18.5607 13.2219 18.0084 13.4535C17.4561 13.6852 17.0336 13.9996 16.7408 14.3968C16.4481 14.7939 16.2984 15.2473 16.2917 15.757C16.2917 16.1806 16.3882 16.548 16.5812 16.8591C16.7808 17.1702 17.0503 17.4349 17.3896 17.6533C17.7289 17.8652 18.1049 18.0439 18.5174 18.1895C18.93 18.3351 19.3458 18.4576 19.765 18.5568L21.6813 19.0334C22.4532 19.2121 23.1951 19.4537 23.907 19.7582C24.6256 20.0627 25.2677 20.4466 25.8333 20.9099C26.4055 21.3733 26.858 21.9326 27.1907 22.5879C27.5234 23.2432 27.6897 24.011 27.6897 24.8913C27.6897 26.0828 27.3836 27.1319 26.7715 28.0387C26.1593 28.9389 25.2744 29.6438 24.1166 30.1535C23.4074 30.4634 22.6061 30.6779 21.7125 30.7968V33.1495H17.9769V30.7688C17.182 30.6484 16.4539 30.4499 15.7927 30.1733C14.6283 29.6835 13.7167 28.9687 13.058 28.0288C12.4059 27.0889 12.0532 25.9437 12 24.5935H15.643C15.6962 25.3017 15.9158 25.8908 16.3017 26.3608C16.6876 26.8307 17.19 27.1815 17.8088 27.4132C18.4342 27.6449 19.1329 27.7607 19.9047 27.7607C20.7099 27.7607 21.4152 27.6415 22.0207 27.4033C22.6328 27.1584 23.1119 26.8208 23.4579 26.3905C23.8039 25.9537 23.9802 25.444 23.9869 24.8615C23.9802 24.332 23.8238 23.8951 23.5178 23.5509C23.2117 23.2001 22.7825 22.9089 22.2303 22.6772C21.6846 22.4389 21.0459 22.2271 20.314 22.0418L17.9884 21.4461C16.305 21.0158 14.9743 20.3639 13.9961 19.4901C13.0247 18.6098 12.539 17.4415 12.539 15.9853C12.539 14.7873 12.865 13.7382 13.5171 12.838C14.1758 11.9378 15.0707 11.2394 16.2019 10.743C16.7574 10.496 17.3491 10.3096 17.9769 10.1838V7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2977_2979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralReward);
export default __webpack_public_path__ + "static/media/referral-reward.278bfd72dc8aa869015cc5379e00b5fc.svg";
export { ForwardRef as ReactComponent };